import { useNavigate } from "react-router-dom"

import { invalidateReleasesListData } from "../../app/services/release"
import { GenerateLandingPagesDialog } from "../../documents/DocumentListBody/generateLandingPages/GenerateLandingPagesDialog"
import { useDocument } from "../DocumentProvider"
import { useSettingsMenu } from "./SettingsMenuProvider"

export function GenerateABMLandingPagesDialog() {
  const document = useDocument()

  const navigate = useNavigate()

  const settingsMenu = useSettingsMenu()

  return document.documentId ? (
    <GenerateLandingPagesDialog
      open={settingsMenu.dialog === "generateABMLandingPages"}
      document={{
        id: document.documentId,
        title: document.documentTitle.displayedTitle,
      }}
      variant="personalizeLandingPageForABM"
      onCloseRequest={async (taskState) => {
        settingsMenu.closeDialog()
        const releaseId = taskState.taskResults?.release?.id
        if (taskState.status === "SUCCEEDED" && releaseId) {
          await invalidateReleasesListData()
          navigate(`/upcoming/${releaseId}?language=${document.locale}`)
        }
      }}
    />
  ) : (
    <></>
  )
}
